import { render, staticRenderFns } from "./LearnMore.vue?vue&type=template&id=84a8c19a&"
import script from "./LearnMore.vue?vue&type=script&lang=js&"
export * from "./LearnMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports